import { ORIGINS } from '@realseas/shared';
import type { CaptainSave } from '@realseas/shared';
import type { Connection } from '../Connection.js';
import { setHTML, esc } from '../dom.js';

export function renderOriginScreen(
  container: HTMLElement,
  conn: Connection,
  captain: CaptainSave,
): void {
  const cards = ORIGINS.map(o => `
    <div class="origin-card" data-origin="${esc(o.id)}">
      <div class="seal" aria-hidden="true">${esc(o.seal)}</div>
      <h3>${esc(o.name)}</h3>
      <div class="epithet">${esc(o.epithet)}</div>
      <div class="divider"></div>
      <p class="blurb">${esc(o.blurb)}</p>
      <div class="stats">
        <div class="reales">${o.startingReales.toLocaleString()} reales</div>
        <div class="bonus">${esc(o.bonusText)}</div>
      </div>
    </div>
  `).join('');

  setHTML(container, `
    <h1 class="title">Cádiz, 1696</h1>
    <p class="subtitle">Captain ${esc(captain.username)}, choose your origin.</p>
    <div class="origin-grid">${cards}</div>
  `);

  container.querySelectorAll<HTMLElement>('.origin-card').forEach(card => {
    card.onclick = () => {
      const id = card.dataset.origin!;
      conn.send({ type: 'pick_origin', originId: id });
    };
  });
}
